module.exports = __webpack_public_path__ + "img/info_icon.3b7c31a6.svg";